import { useEffect, useState } from 'react'

import { cn } from '@/lib/cn'
import { EVENT_KEYS } from '@/shared/custom-event'

export const GlobalAppLoading = () => {
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const handleLoading = (event: Event) => {
      setIsLoading((event as CustomEvent).detail.loading)
    }
    window.addEventListener(EVENT_KEYS.GLOBAL_APP_LOADING, handleLoading)
    return () => {
      window.removeEventListener(EVENT_KEYS.GLOBAL_APP_LOADING, handleLoading)
    }
  }, [])

  return (
    <div
      className={cn('fixed top-0 left-0 right-0 z-9999 transition-opacity', isLoading ? 'opacity-100' : 'opacity-0')}
    >
      <div className='w-full h-1 bg-neutral-80 overflow-hidden'>
        <div className='h-full bg-primary-20 animate-progress-indeterminate' />
      </div>
    </div>
  )
}
